import request from '@/utils/request'

// 获取用户图表集合,以分类树的形式展现
export function getCharts(id) {
  return request({
    url: `/users/${id}/charts`,
    method: 'get'
  })
}

// 获取目标图表对象
export function getChartOptions(id) {
  return request({
    url: `/charts/${id}`,
    method: 'get'
  })
}

// 获取图表数据
export function getChartDataSet(id) {
  return request({
    url: `/charts/${id}/output`,
    method: 'get'
  })
}
// 获取用户的快速入口模板列表，可能的返回值包括404, 空列表，有值列表
// 列表中元素为 {id,name,type}，分别表示模板的id，名称，类型(普通-0，查询-1)
export function getQuickTemplates(id) {
  return request({
    url: `/users/${id}/quicktemplates`,
    method: 'get'
  })
}
// 获取图表钻取数据
export function getChartConnect(id, fieldId, data) {
  return request({
    url: `/charts/${id}/fields/${fieldId}/output`,
    method: 'post',
    data
  })
}

// 获取目标决策分类
export function getStrategyCategorys(id) {
  return request({
    url: `/strategycategorys/${id}`,
    method: 'get'
  })
}
// 获取决策信息
export function getDecision(id) {
  return request({
    url: `/strategys/${id}`,
    method: 'get'
  })
}
// 获取用户决策集合
export function getStrategy(userId, type = 0) {
  const params = { type }
  return request({
    url: `/users/${userId}/strategys`,
    method: 'get',
    params
  })
}

// 获取用户决策集合
export function getSingleDecision(id) {
  return request({
    url: `/strategys/${id}/`,
    method: 'get'
  })
}

// 获取图表数据
export function getDecisionChartData(id) {
  return request({
    url: `/strategys/${id}/output`,
    method: 'get'
  })
}

// 获取联动数据
export function getDecisionLinkData(id, linkId, data) {
  return request({
    url: `/strategys/${id}/link/${linkId}/output`,
    method: 'post',
    data
  })
}
// 获取数据列表数据
export function getListOutPut(id, datalistid, params) {
  return request({
    url: `/strategys/${id}/datalist/${datalistid}/output`,
    method: 'get',
    params
  })
}
// 获取数据列表关联的目标单据
export function getLinkForm(id, datalistid, data) {
  return request({
    url: `/strategys/${id}/datalist/${datalistid}/forms`,
    method: 'post',
    data
  })
}
